<template>
  <div class="order-detail-container">
    <!-- 页头 -->
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-back" type="primary" @click="$router.go(-1)">返回</el-button>
        <span class="title">订单详情</span>
      </div>
    </div>

    <!-- 详情内容 -->
    <el-card v-loading="loading">
      <!-- 基本信息 -->
      <div class="detail-section">
        <h3 class="section-title">基本信息</h3>
        <el-row :gutter="20">
          <!-- <el-col :span="6">
            <div class="info-item">
              <span class="label">订单编号：</span>
              <span class="value">{{ orderData?.order?.purchasingOrderID }}</span>
            </div>
          </el-col> -->
          <el-col :span="8">
            <div class="info-item">
              <span class="label">订单名称：</span>
              <span class="value">{{ orderData?.order?.orderName }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">创建时间：</span>
              <span class="value">{{ formatDateTime(orderData?.order?.createdAt) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">状态：</span>
              <el-tag :type="getStatusType(orderData?.order?.status)">
                {{ getStatusText(orderData?.order?.status) }}
              </el-tag>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
        
          <el-col :span="8">
            <div class="info-item">
              <span class="label">未付金额：</span>
              <span class="value">¥{{ orderData?.order?.unpaidMoney || 0 }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">已付金额：</span>
              <span class="value">¥{{ orderData?.order?.payMoney || 0 }}</span>
            </div>
          </el-col>
          
          <el-col :span="8">
            <div class="info-item">
              <span class="label">总金额：</span>
              <span class="value" style="color: #f56c6c; font-weight: 500;">¥{{ orderData?.details?.totalMoney || 0 }}</span>
            </div>
          </el-col>
          
        </el-row>
      </div>

      <!-- 商品信息 -->
      <div class="detail-section">
        <h3 class="section-title">商品信息</h3>
        <el-table :data="orderData?.details?.list || []" border style="width: 100%"
          :show-summary="true"
          :summary-method="getSummaries">
          <el-table-column prop="goodsName" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="goodsSpec" label="规格" align="center"></el-table-column>
          <el-table-column prop="goodsUnit" label="单位" align="center"></el-table-column>
          <el-table-column prop="price" label="单价" width="100" align="center">
            <template slot-scope="scope">
              ¥{{ scope.row.price }}
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量" width="100" align="center"></el-table-column>
          <el-table-column prop="totalAmount" label="金额" width="100" align="center">
            <template slot-scope="scope">
              ¥{{ scope.row.totalAmount }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 供应商信息 -->
      <div class="detail-section">
        <h3 class="section-title">供应商信息</h3>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="info-item">
              <span class="label">供应商名称：</span>
              <span class="value">{{ orderData?.order?.supplierName }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">供应商地址：</span>
              <span class="value">{{ orderData?.order?.shipperAddress }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">联系人：</span>
              <span class="value">{{ orderData?.order?.contactName }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">联系电话：</span>
              <span class="value">{{ orderData?.order?.contactPhone }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">负责人：</span>
              <span class="value">{{ orderData?.order?.shipperName }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">负责人电话：</span>
              <span class="value">{{ orderData?.order?.shipperPhone }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 审批流程 -->
      <div class="detail-section">
        <h3 class="section-title">审批流程</h3>
        <div class="flow-steps">
          <div class="flow-wrapper">
            <div v-for="node in orderData?.workflow?.nodes" 
                 :key="node.nodeId" 
                 class="flow-step"
                 :class="{ 'is-active': node.isActive, 'is-completed': node.isCompleted }">
              <!-- 步骤标题 -->
              <div class="step-header">
                <div class="step-number">{{ node.step }}</div>
                <div class="step-title">{{ node.nodeName }}</div>
                <el-tag size="mini" :type="getNodeStatusType(node.status)">
                  {{ getNodeStatusText(node.status) }}
                </el-tag>
              </div>

              <!-- 审批人列表 -->
              <div class="step-content">
                <div v-for="approver in node.approvers" 
                     :key="approver.approverId" 
                     class="approver-item">
                  <div class="approver-info">
                    <span class="approver-name">{{ approver.approverName }}</span>
                    <el-tag size="mini" :type="getApproverStatusType(approver.status)">
                      {{ getApproverStatusText(approver.status) }}
                    </el-tag>
                  </div>
                  <div class="approve-time" v-if="approver.approveTime">
                    {{ formatDateTime(approver.approveTime) }}
                  </div>
                  <span v-if="approver.remark" class="approve-comment">审核意见：{{ approver.remark }}</span>
                 </div>
              </div>

              <!-- 连接线 -->
              <div class="step-line" v-if="node.step !== orderData?.workflow?.nodes.length">
                <i class="el-icon-right" style="color: #f56c6c;"></i>
                
              </div>
            </div>
          </div>
        </div>
        
        <!-- 修改审批按钮的显示条件 -->
        <div class="button-container">
          <div class="approve-buttons" v-if="showApproveButtons">
            <el-button 
              size="medium" 
              @click="handleReject"
              style="margin-right: 10px;">
              驳回
            </el-button>
            <el-button 
              size="medium" 
              type="primary" 
              @click="handleApprove">
              通过
            </el-button>
          </div>
          <div class="payment-button" v-if="showPaymentButton">
            <el-button 
              size="medium" 
              type="primary" 
              @click="handlePayment">
              申请付款
            </el-button>
          </div>
        </div>
      </div>

      <!-- 备注信息 -->
      <div class="detail-section" v-if="orderData?.order?.remark">
        <h3 class="section-title">备注信息</h3>
        <div class="remark-content">
          {{ orderData?.order?.remark }}
        </div>
      </div>
    </el-card>

    <!-- 添加审核意见弹窗 -->
    <el-dialog
      :title="actionType === 'approve' ? '审核通过' : '驳回'"
      :visible.sync="approveDialogVisible"
      width="400px"
      :close-on-click-modal="false">
      <el-input
        type="textarea"
        v-model="approveComment"
        :rows="2"
        placeholder="请输入审核意见">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitApprove">确定</el-button>
      </div>
    </el-dialog>

    <!-- 申请付款对话框 -->
    <el-dialog title="申请付款" :visible.sync="paymentDialogVisible" width="650px" :close-on-click-modal="false"
      custom-class="payment-dialog" class="payment-dialog-scroll">
      <div v-loading="paymentLoading" class="payment-form-wrapper">
        <el-form ref="paymentForm" :model="paymentForm" :rules="paymentRules" label-width="120px">
          <!-- 订单基本信息 -->
          <!-- <el-form-item label="订单名称">
            <el-input v-model="paymentForm.orderName" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="订单总金额">
            <el-input v-model="paymentForm.totalAmount" disabled>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="已付金额">
            <el-input v-model="paymentForm.paidAmount" disabled>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="申请中金额">
            <el-input v-model="paymentForm.applyingAmount" disabled>
              <template slot="append">元</template>
            </el-input>
          </el-form-item> -->
          <el-form-item label="申请金额" prop="applyAmount">
            <el-input-number v-model="paymentForm.applyAmount" :min="0" :precision="2" :step="100" style="width: 100%"
              controls-position="right">
            </el-input-number>
          </el-form-item>

          <!-- 发票上传 -->
          <el-form-item label="发票上传" prop="invoice">
            <el-upload class="upload-demo" action="/api/api/v1/upload/file" :headers="uploadHeaders"
              :on-success="handleUploadSuccess" 
              :on-error="handleUploadError"
              :on-preview="handlePreview"
              :on-remove="handleRemove" 
              :before-upload="beforeUpload" 
              :file-list="paymentForm.fileList" multiple
              :limit="3">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过10MB</div>
            </el-upload>
          </el-form-item>

          <!-- 工作流和收款信息 -->
          <el-form-item label="工作流" prop="workflowId">
            <el-select v-model="paymentForm.workflowId" placeholder="请选择工作流" style="width: 100%">
              <el-option v-for="item in workflowOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="收款类型" prop="paymentType">
            <el-select v-model="paymentForm.paymentType" placeholder="请选择收款类型" style="width: 100%">
              <el-option v-for="item in paymentTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="收款渠道" prop="paymentChannel">
            <el-select v-model="paymentForm.paymentChannel" placeholder="请选择收款渠道" style="width: 100%">
              <el-option v-for="item in paymentChannelOptions" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="收款人" prop="payee">
            <el-input v-model="paymentForm.payee"></el-input>
          </el-form-item>

          <el-form-item label="收款账号" prop="accountNo">
            <el-input v-model="paymentForm.accountNo"></el-input>
          </el-form-item>

          <el-form-item label="收款银行" prop="bankName">
            <el-input v-model="paymentForm.bankName"></el-input>
          </el-form-item>

          <el-form-item label="银行行号" prop="bankCode">
            <el-input v-model="paymentForm.bankCode"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="paymentDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="submitPayment">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'OrderDetail',
  data() {
    return {
      loading: false,
      orderId: this.$route.query.orderId,
      orderData: null,
      approveDialogVisible: false,
      approveComment: '',
      actionType: 'approve', // 'approve' 或 'reject'
      paymentDialogVisible: false,
      paymentLoading: false,
      detailForm: {
        items: [],
        totalAmount: 0
      },
      paymentTypeOptions: [],
      paymentChannelOptions: [],
      paymentForm: {
        orderId: null,
        orderName: '',
        totalAmount: 0,
        paidAmount: 0,
        applyingAmount: 0,
        applyAmount: 0,
        workflowId: '',
        paymentType: '',
        paymentChannel: '',
        payee: '',
        accountNo: '',
        bankName: '',
        bankCode: '',
        invoice: '',
        fileList: []
      },
      paymentRules: {
        applyAmount: [{ required: true, message: '请输入申请金额', trigger: 'blur' }],
        workflowId: [{ required: true, message: '请选择工作流', trigger: 'change' }],
        paymentType: [{ required: true, message: '请选择收款类型', trigger: 'change' }],
        paymentChannel: [{ required: true, message: '请选择收款渠道', trigger: 'change' }],
        payee: [{ required: true, message: '请输入收款人', trigger: 'blur' }],
        accountNo: [{ required: true, message: '请输入收款账号', trigger: 'blur' }],
        bankName: [{ required: true, message: '请输入收款银行', trigger: 'blur' }],
        bankCode: [{ required: true, message: '请输入银行行号', trigger: 'blur' }]
      },
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      workflowOptions: []
    }
  },
  created() {
    this.fetchOrderDetail()
  },
  computed: {
   
    totalAmount() {
      return this.detailForm.items.reduce((sum, item) => sum + (item.amount || 0), 0)
    },
  
    // 修改审批按钮显示逻辑
    showApproveButtons() {
      if (!this.orderData?.order) return false
      // 只在待审核(2)或审核中(3)状态显示审批按钮
      return [2, 3].includes(this.orderData.order.status)
      // 只在当前用户是审批人时显示审批按钮
      const currentUser = this.$store.state.user.name
      const currentApprover = this.orderData.order.now_approver
      return currentUser === currentApprover
      
   

    },
    // 显示申请付款按钮
    showPaymentButton() {
      if (!this.orderData?.order) return false
      // 只在订单状态为已通过(4)时显示申请付款按钮
      return this.orderData.order.status === 4
    }
  },
  methods: {
    // 获取订单详情
    async fetchOrderDetail() {
      try {
        this.loading = true
        const response = await request({
          url: '/api/v1/purchasing-order/detail',
          method: 'post',
          data: {
            orderId: this.orderId
          }
        })

        if (response.status === 1 && response.data) {
          this.orderData = response.data
          // 添加调试日志
          console.log('订单详情数据:', this.orderData)
          console.log('当前用户:', this.$store.state.user.name)
          console.log('当前审批人:', this.orderData.order.now_approver)
          console.log('工作流节点:', this.orderData.workflow?.nodes)
          
          // 调试当前用户的所有节点
          const currentUser = this.$store.state.user.name
          const userNodes = this.orderData.workflow?.nodes?.filter(node => 
            node.approvers?.some(approver => approver.approverName === currentUser)
          )
          console.log('当前用户的所有节点:', userNodes)
          
          // 调试当前待审批节点
          const pendingNode = userNodes?.find(node => {
            const userApprover = node.approvers.find(approver => 
              approver.approverName === currentUser
            )
            return [0, 1].includes(node.status) && 
                   [0, 1].includes(userApprover.status) &&
                   node.step === this.orderData.order.now_step
          })
          console.log('当前待审批节点:', pendingNode)
        } else {
          throw new Error(response.message || '获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error(error.message || '获取订单详情失败')
      } finally {
        this.loading = false
      }
    },

    // 格式化时间
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    getApproverStatusText(status) {
      // 将 status 转换为数字类型，以确保正确匹配
      const statusNum = Number(status);

      const statusMap = {
        0: '未处理',
        1: '处理中',
        2: '已拒绝',
        3: '已通过',
        4: '已转交',
        5: '已回退'
      }

      // 添加调试日志
      console.log('Approver status:', status, 'Mapped status:', statusMap[statusNum]);

      return statusMap[statusNum] || '未知状态';
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        1: '草稿',
        2: '待审核',
        3: '审核中',
        4: '已通过',
        5: '已拒绝',
        6: '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        1: 'info',         // 草稿
        2: 'warning',     // 待审核
        3: 'primary',     // 审核中
        4: 'success',    // 已通过
        5: 'danger',     // 已拒绝
        6: 'info',       // 已取消
      }
      return statusMap[status] || 'info'
    },
    // 获取时间线节点类型
    getTimelineNodeType(status) {
      const typeMap = {
        1: 'warning',
        2: 'primary',
        3: 'success',
        4: 'danger'
      }
      return typeMap[status] || 'info'
    },
      // 获取状态标签类型
      getStatusTagType(status) {
      const typeMap = {
        0: 'info',    // 未处理
        1: 'warning', // 处理中
        2: 'danger',  // 已拒绝
        3: 'success', // 已通过
        4: 'info',    // 已转交
        5: 'warning'  // 已回退
      }
      return typeMap[status] || 'info'
    },

    // 表格合计行
    getSummaries(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.property === 'totalAmount') {
          const values = this.orderData?.details?.list?.map(item => Number(item.totalAmount)) || []
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + value
            } else {
              return prev
            }
          }, 0)
          sums[index] = '¥' + sum
        } else {
          sums[index] = ''
        }
      })
      return sums
    },

    // 获取节点状态文本
    getNodeStatusText(status) {
      const statusMap = {
        1: '进行中',
        2: '已完成',
        3: '已拒绝',
        4: '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取节点状态类型
    getNodeStatusType(status) {
      const typeMap = {
        1: 'primary',  // 进行中
        2: 'success',  // 已完成
        3: 'danger',   // 已拒绝
        4: 'info'      // 已取消
      }
      return typeMap[status] || 'info'
    },

    // 获取审批人状态类型
    getApproverStatusType(status) {
      const typeMap = {
        1: 'warning',  // 待处理
        2: 'primary',  // 处理中
        3: 'success',  // 已通过
        4: 'danger',   // 已拒绝
        5: 'info'      // 已转交
      }
      return typeMap[status] || 'info'
    },

    // 处理通过审核
    handleApprove() {
      this.actionType = 'approve'
      this.approveDialogVisible = true
    },
    
    // 处理驳回
    handleReject() {
      this.actionType = 'reject'
      this.approveDialogVisible = true
    },
    
    // 提交审核
    async submitApprove() {
      if (!this.approveComment) {
        this.$message.warning('请输入审核意见')
        return
      }

      try {
        const res = await request({
          url: '/api/v1/purchasing-order/approve',
          method: 'post',
          data: {
            order_id: this.orderId,
            approved: this.actionType === 'approve' ? 2 : 1, // 2-同意，1-拒绝
            comment: this.approveComment
          }
        })

        if (res.status === 1) {
          this.$message.success(this.actionType === 'approve' ? '审核通过成功' : '已驳回')
          this.approveDialogVisible = false
          // 刷新详情数据
          await this.fetchOrderDetail()
        } else {
          throw new Error(res.msg || '操作失败')
        }
      } catch (error) {
        console.error('审核失败:', error)
        this.$message.error(error.message || '审核失败')
      }
    },

    // 处理申请付款按钮点击
    handlePayment() {
      this.paymentDialogVisible = true
      this.paymentLoading = true
      
      // 初始化表单数据
      this.paymentForm = {
        orderId: this.orderId,
        totalAmount: this.orderData.order.money || 0,
        paidAmount: this.orderData.order.paid_money || 0,
        applyAmount: 0,
        workflowId: '',
        paymentType: '',
        paymentChannel: '',
        payee: '',
        accountNo: '',
        bankName: '',
        bankCode: '',
        fileList: []
      }

      // 获取必要的选项数据
      Promise.all([
        this.getWorkflowList(),
        this.getPaymentTypeOptions(),
        this.getPaymentChannelOptions()
      ]).finally(() => {
        this.paymentLoading = false
      })
    },

    // 文件上传前的校验
    beforeUpload(file) {
      const isValidType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error('只能上传 JPG/PNG/PDF 格式的文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB!')
        return false
      }
      return true
    },

    // 处理文件上传成功
    handleUploadSuccess(response, file, fileList) {
      if (response.status === 1) {
        this.$message.success('上传成功')
        this.paymentForm.invoice = response.data.SavePath
      } else {
        this.$message.error('上传失败')
      }
    },

    // 处理文件上传失败
    handleUploadError() {
      this.$message.error('上传失败')
    },

    // 处理文件预览
    handlePreview(file) {
      if (file.url) {
      window.open(file.url)
    }
    },

    // 处理文件移除
    handleRemove(file, fileList) {
      this.paymentForm.fileList = fileList
      this.paymentForm.invoice = '' // 清空发票路径
    },

    // 提交付款申请
    async submitPayment() {
      try {
        await this.$refs.paymentForm.validate()
        
        const params = {
          order_id: this.orderId,
          invoice_path: this.paymentForm.invoice || '',
          amount: this.paymentForm.applyAmount,
          remark: '预付款',
          work_flow_id: this.paymentForm.workflowId,
          pay_channel: this.paymentForm.paymentChannel,
          pay_account: this.paymentForm.accountNo,
          pay_type: this.paymentForm.paymentType,
          supplier_pay_method: this.paymentForm.paymentType,
          supplier_pay_channel: this.paymentForm.paymentChannel,
          supplier_bank_name: this.paymentForm.bankName,
          supplier_bank_account: this.paymentForm.accountNo,
          supplier_bank_code: this.paymentForm.bankCode,
          supplier_name: this.paymentForm.payee
        }

        const res = await request({
          url: '/api/v1/purchasing-order/payment/save',
          method: 'post',
          data: params
        })

        if (res.status === 1) {
          this.$message.success('申请付款成功')
          this.paymentDialogVisible = false
          // 跳转到我的付款申请页面
          this.$router.push({
            path: '/finance/mypayment'  // 假设这是我的付款申请页面的路由
          })
        } else {
          throw new Error(res.msg || '提交失败')
        }
      } catch (error) {
        console.error('提交付款申请失败:', error)
        this.$message.error(error.message || '提交失败')
      }
    },

    // 获取工作流列表
    async getWorkflowList() {
      try {
        const res = await request({
          url: '/api/v1/process/by-type',
          method: 'post',
          data: {
            code: '100005' // 付款类型的工作流
          }
        })
        if (res.status === 1) {
          this.workflowOptions = res.data.map(item => ({
            value: item.processId,
            label: item.processName
          }))
        }
      } catch (error) {
        console.error('获取工作流列表失败:', error)
      }
    },

    // 获取收款类型选项
    async getPaymentTypeOptions() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'GYSSKFS',
            dictItemName: ''
          }
        })
        if (res.status === 1) {
          this.paymentTypeOptions = res.data.map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取支付类型选项失败:', error)
      }
    },

    // 获取收款渠道选项
    async getPaymentChannelOptions() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'GYSSKQD',
            dictItemName: ''
          }
        })
        if (res.status === 1) {
          this.paymentChannelOptions = res.data.map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取支付渠道选项失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-detail-container {
  padding: 20px;

  .page-header {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-left {
      display: flex;
      align-items: center;
      gap: 15px;

      .title {
        font-size: 20px;
        font-weight: 500;
      }
    }
  }

  .detail-section {
    margin-bottom: 30px;

    .section-title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
      margin-bottom: 20px;
      padding-left: 10px;
      border-left: 4px solid #409EFF;
    }

    .info-item {
      margin-bottom: 15px;
      
      .label {
        color: #606266;
        margin-right: 10px;
      }

      .value {
        color: #303133;
      }
    }

    .remark-content {
      padding: 15px;
      background-color: #f5f7fa;
      border-radius: 4px;
      color: #606266;
      line-height: 1.6;
    }
  }
}

.flow-steps {
  display: flex;
  align-items: stretch;
  padding: 20px 0;
  overflow-x: auto;

  .flow-wrapper {
    display: flex;
    flex: 1;
    align-items: stretch;
  }

  .flow-step {
    flex: 1;
    min-width: 250px;
    position: relative;
    padding: 0 20px;
    display: flex;
    flex-direction: column;

    &.is-completed {
      .step-number {
        background-color: #67C23A;
      }
    }

    &.is-active {
      .step-number {
        background-color: #409EFF;
      }
    }

    .step-header {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      
      .step-number {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: #909399;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        font-size: 14px;
      }

      .step-title {
        font-weight: 500;
        margin-right: 10px;
      }
    }

    .step-content {
      flex: 1;
      background: #f8f9fa;
      border-radius: 4px;
      padding: 15px;
      height: 100%;
      box-sizing: border-box;

      .approver-item {
        padding: 10px 0;
        border-bottom: 1px dashed #EBEEF5;

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        &:first-child {
          padding-top: 0;
        }

        .approver-info {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 5px;

          .approver-name {
            font-weight: 500;
          }
        }

        .approve-time {
          font-size: 12px;
          color: #909399;
          margin-bottom: 5px;
        }

        .approve-comment {
          font-size: 13px;
          color: #606266;
          background: #fff;
          padding: 1px;
          border-radius: 4px;
        }
      }
    }

    .step-line {
      position: absolute;
      top: 12px;
      right: -10px;
      color: #DCDFE6;
      font-size: 20px;
      z-index: 1;
    }
  }
}

// 适配移动端
@media screen and (max-width: 768px) {
  .flow-steps {
    flex-direction: column;
    
    .flow-step {
      width: 100%;
      margin-bottom: 20px;
      
      .step-line {
        transform: rotate(90deg);
        right: 50%;
        top: auto;
        bottom: -25px;
      }
    }
  }
}

// 添加按钮容器样式
.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

// 审核弹窗样式
.approve-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }

  :deep(.el-textarea__inner) {
    border-radius: 4px;
  }
}

.readonly-item {
  :deep(.el-form-item__content) {
    line-height: 40px;
  }
}

.unit {
  margin-left: 10px;
  color: #606266;
}

.payment-dialog {
  .el-input-number {
    width: 200px;
  }
}

.el-input-number {
  width: 100%;
}

.upload-demo {
  .el-upload__tip {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
  }
}

.payment-dialog-scroll {
  :deep(.el-dialog__body) {
    max-height: calc(90vh - 150px);
    overflow-y: auto;
  }
}

.payment-form-wrapper {
  padding: 20px;
}
</style> 